export const newsColumnsConfig = {
  TITLE: "Title",
  DESCRIPTION: "Description",
  MEDIATYPE: "Media Type",
  MEDIAURL: "Media",
  AUTHOR: "Author",
  CREATED: "Created At",
  UPDATED: "Updated At",
  ACTIONS: "Actions",
  message: "Are you sure you want to delete this news item?",
};
